import React, { ReactElement, memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

//styles
import styles from "../Card.v4.scss";

//helpers
import { isEmpty } from "@swiggy-private/core-ui";

//test-ids
import { CARD_PAYMENT_METHOD_TEST_IDS } from "@swiggy-private/payment-test-ids";

interface CvvMessageProps {
    message?: string;
    selected?: boolean;
}

function CvvMessage({ message, selected }: CvvMessageProps): ReactElement | null {
    if (isEmpty(message) || !selected) {
        return null;
    }
    return (
        <Text
            as="p"
            variant="V2.body3.neutral.medium"
            color="text_Low_Emphasis"
            className={styles.cvvMessage}
            aria-label={message}
            data-testid={CARD_PAYMENT_METHOD_TEST_IDS.CVV_MESSAGE}
        >
            {message}
        </Text>
    );
}

export default memo(CvvMessage);
